// Firebase Studio's preview environment needs extra time for persisted auth
// state to stabilize after onAuthStateChanged's first firing — noticeably
// more than a normal deployment. This was found empirically (see useAuth())
// and is shared here so every auth-gated page applies the same settle
// window instead of each guessing its own constant.
export function isStudioEnvironment(): boolean {
  return typeof window !== 'undefined' && window.location.hostname.includes('studio--');
}

export function getAuthStabilizationDelay(): number {
  return isStudioEnvironment() ? 1000 : 500;
}
